import { render, staticRenderFns } from "./tiscSection.vue?vue&type=template&id=c0e7db4e&scoped=true&"
import script from "./tiscSection.vue?vue&type=script&lang=js&"
export * from "./tiscSection.vue?vue&type=script&lang=js&"
import style0 from "./tiscSection.vue?vue&type=style&index=0&id=c0e7db4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e7db4e",
  null
  
)

export default component.exports